import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import last from 'lodash/last';
import { ANALYTICS_BRIDGE_CHANNEL, OPERATIONAL_EVENT_TYPE, SCREEN_EVENT_TYPE, TRACK_EVENT_TYPE, UI_EVENT_TYPE } from '../../constants';
import { getImperativeAnalyticsDataFromArguments } from './utils';
export var fireAnalytics = function fireAnalytics(event, type, payload) {
  // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
  var castedEvent = event;
  var clonedEvent = castedEvent.clone();
  if (!clonedEvent) {
    throw new Error("Cannot clone an event after it's been fired.");
  }
  clonedEvent.update(_objectSpread(_objectSpread({}, payload), {}, {
    analyticsType: type
  })).fire(ANALYTICS_BRIDGE_CHANNEL);
};
var getActionSubjectFromContext = function getActionSubjectFromContext(event) {
  // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
  var castedEvent = event;
  return last(castedEvent.context.map(function (i) {
    return i.component || i.componentName;
  }).filter(Boolean));
};
export var fireUIAnalytics = function fireUIAnalytics(event) {
  if (!event.clone) {
    throw new Error('There is no analytics event from Atlaskit in UI event');
  }
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }
  var _getImperativeAnalyti = getImperativeAnalyticsDataFromArguments(rest),
    argumentsAction = _getImperativeAnalyti.action,
    argumentsActionSubject = _getImperativeAnalyti.actionSubject,
    actionSubjectId = _getImperativeAnalyti.actionSubjectId,
    attributes = _getImperativeAnalyti.attributes;
  var castedEvent = event;
  var action = event.payload && event.payload.action || argumentsAction;
  var actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || getActionSubjectFromContext(castedEvent);
  if (!action) {
    throw new Error('Mandatory "action" field is missing from UI event');
  }
  if (!actionSubject) {
    throw new Error('Mandatory "actionSubject" field is missing from UI event');
  }
  fireAnalytics(event, UI_EVENT_TYPE, {
    action: action,
    actionSubject: actionSubject,
    actionSubjectId: actionSubjectId,
    attributes: attributes
  });
};
export var fireTrackAnalytics = function fireTrackAnalytics(event) {
  if (!event.clone) {
    throw new Error('There is no analytics event from Atlaskit in Track event');
  }
  for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    rest[_key2 - 1] = arguments[_key2];
  }
  var _getImperativeAnalyti2 = getImperativeAnalyticsDataFromArguments(rest),
    action = _getImperativeAnalyti2.action,
    actionSubject = _getImperativeAnalyti2.actionSubject,
    actionSubjectId = _getImperativeAnalyti2.actionSubjectId,
    attributes = _getImperativeAnalyti2.attributes;
  if (!action) {
    throw new Error('Mandatory "action" field is missing from Track event');
  }
  if (!actionSubject) {
    throw new Error('Mandatory "actionSubject" field is missing from Track event');
  }
  fireAnalytics(event, TRACK_EVENT_TYPE, {
    action: action,
    actionSubject: actionSubject,
    actionSubjectId: actionSubjectId,
    attributes: attributes
  });
};
export var fireOperationalAnalytics = function fireOperationalAnalytics(event) {
  if (!event.clone) {
    throw new Error('There is no analytics event from Atlaskit in Operational event');
  }
  for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    rest[_key3 - 1] = arguments[_key3];
  }
  var _getImperativeAnalyti3 = getImperativeAnalyticsDataFromArguments(rest),
    action = _getImperativeAnalyti3.action,
    actionSubject = _getImperativeAnalyti3.actionSubject,
    actionSubjectId = _getImperativeAnalyti3.actionSubjectId,
    attributes = _getImperativeAnalyti3.attributes;
  if (!action) {
    throw new Error('Mandatory "action" field is missing from Operational event');
  }
  if (!actionSubject) {
    throw new Error('Mandatory "actionSubject" field is missing from Operational event');
  }
  fireAnalytics(event, OPERATIONAL_EVENT_TYPE, {
    action: action,
    actionSubject: actionSubject,
    actionSubjectId: actionSubjectId,
    attributes: attributes
  });
};
export var fireScreenAnalytics = function fireScreenAnalytics(event) {
  if (!event.clone) {
    throw new Error('There is no analytics event from Atlaskit in Screen event');
  }
  for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    rest[_key4 - 1] = arguments[_key4];
  }
  var _getImperativeAnalyti4 = getImperativeAnalyticsDataFromArguments(rest),
    attributes = _getImperativeAnalyti4.attributes;
  fireAnalytics(event, SCREEN_EVENT_TYPE, {
    attributes: attributes
  });
};